import { PopupWindow } from "./PopupWindow";

/**
 * Can be used as an alternative for `prompt("alertMessage");`
 */
export class PromptWindow extends PopupWindow<string>
{
	private _inputElement: HTMLInputElement;

	constructor(message: string, placeholder: string, title: string, ok: string, cancel: string, backdrop: boolean)
	{
		super(title, message, backdrop, ok, cancel);
		this._inputElement = document.createElement("input");
		this._inputElement.value = placeholder;
		this._additionalElements = [this._inputElement];

		this.cancelValue = null;
	}

	protected override okClicked = () =>
	{
		this.okValue = this._inputElement.value;
		super.okClicked();
	};

	public static open(message: string, placeholder: string = "", title: string = "Submit", ok: string = "Submit", cancel: string = "Cancel", backdrop: boolean = false)
	{
		return new PromptWindow(message, placeholder, title, ok, cancel, backdrop).open();
	}
}